import { DeleteOutlined, DownOutlined, UpOutlined } from "@ant-design/icons";
import { Button, Divider, Tag } from "antd";
import { useTranslation } from "react-i18next";
import { calculateGrandTotal } from "../../modules/calculateGrandTotal";
import { formatCurrency } from "../../modules/formatCurrency";
import { getAvailableRooms } from "../../modules/getAvailableRooms";

export const BookingSideBarContent = (props) => {
  const {
    selectedAdults,
    selectedChildren,
    fromdate,
    todate,
    currency,
    convertAmount,
    expandedRooms,
    rooms,
    bookingSidebar,
    extraBedPrice,
    roomNameColor,
    handleRemoveAddOnService,
    toggleRoomExpand,
    handleRemoveRoomType,
    handleRemoveIndividualRoom,
    handleGuestInput,
    handleContinueToCheckout,
    toggleExtraBed,
    handleRoomChange,
    totaldays,
  } = props;

  const { t } = useTranslation();
  return (
    <div className="booking-sidebar-content">
      {bookingSidebar
        .reduce((acc, plan) => {
          if (plan.type === "addonservice") {
            const existing = acc.find(
              (item) => item.serviceId === plan.serviceId
            );
            if (existing) {
              existing.quantity += 1;
            } else {
              acc.push({ ...plan, quantity: 1 });
            }
          } else {
            acc.push(plan);
          }
          return acc;
        }, [])
        .map((plan, index) => (
          <div key={index}>
            {plan.type === "addonservice" ? (
              <div className="addonservice-summary text-white">
                <div
                  className="justify-content-between"
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <p>
                    <strong>{t("homescreen.add_on_service")}:</strong>
                  </p>
                  <DeleteOutlined
                    onClick={() => handleRemoveAddOnService(plan.serviceId)}
                    style={{ cursor: "pointer", color: "red" }}
                  />
                </div>
                <p>
                  <strong>{plan.serviceName}:</strong>{" "}
                  <Tag color="green">
                    {" "}
                    {formatCurrency(plan.servicePrice, currency, convertAmount)}
                    {currency}
                  </Tag>{" "}
                  {plan.chargeType}
                </p>
                <p>
                  <strong>{t("homescreen.quantity")}:</strong> {plan.quantity}
                </p>
              </div>
            ) : (
              <div className="rate-plan-summary text-white">
                <div
                  onClick={() => toggleRoomExpand(plan.roomId)}
                  className="justify-content-between"
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <h5
                    style={{
                      color: "#FFF",
                      fontFamily: "Bebas Neue",
                      fontSize: "28px",
                    }}
                  >
                    <strong>
                      {rooms.find((r) => r._id === plan.roomId)?.name}
                    </strong>
                  </h5>
                  <div>
                    {expandedRooms[plan.roomId] ? (
                      <DownOutlined />
                    ) : (
                      <UpOutlined />
                    )}
                    <DeleteOutlined
                      onClick={() => handleRemoveRoomType(plan.roomId)}
                      style={{
                        cursor: "pointer",
                        color: "red",
                        marginLeft: "10px",
                      }}
                    />
                  </div>
                </div>

                <p>
                  <strong>{t("homescreen.room_rate")}:</strong>{" "}
                  <Tag color="green">
                    {formatCurrency(
                      plan.totalRate * plan.selectedRooms,
                      currency,
                      convertAmount
                    )}{" "}
                    {currency}
                  </Tag>
                </p>

                {!expandedRooms[plan.roomId] && (
                  <div>
                    <p>
                      <strong>{t("homescreen.rate_plan")}:</strong>{" "}
                      {plan.ratePlanName}
                    </p>
                    {[...Array(plan.selectedRooms).keys()].map((roomIndex) => (
                      <div key={roomIndex} className="guest-inputs mt-4">
                        <div className="justify-content-between mb-4">
                          <strong>
                            {t("homescreen.room")} {roomIndex + 1}
                          </strong>
                          <DeleteOutlined
                            onClick={() =>
                              handleRemoveIndividualRoom(
                                plan.ratePlanId,
                                plan.roomId,
                                roomIndex
                              )
                            }
                            style={{
                              cursor: "pointer",
                              color: "red",
                            }}
                          />
                        </div>

                        <div
                          className="d-flex align-items-center"
                          style={{ gap: "15px" }}
                        >
                          <label style={{ whiteSpace: "nowrap" }}>
                            <strong>{t("homescreen.adults")}:</strong>
                          </label>
                          <select
                            value={plan.selectedAdults?.[roomIndex] || 0}
                            onChange={(e) =>
                              handleGuestInput(
                                plan.ratePlanId,
                                plan.roomId,
                                roomIndex,
                                "adults",
                                Number(e.target.value)
                              )
                            }
                            className="form-select"
                            style={{
                              width: "60px",
                              fontSize: "10px",
                              padding: "2px",
                            }}
                          >
                            {(() => {
                              const room = rooms.find(
                                (r) => r._id === plan.roomId
                              );
                              return [
                                ...Array(
                                  (room?.maxadult || selectedAdults) + 1
                                ).keys(),
                              ].map((i) => (
                                <option key={i} value={i}>
                                  {i}
                                </option>
                              ));
                            })()}
                          </select>

                          <label style={{ whiteSpace: "nowrap" }}>
                            <strong>{t("homescreen.children")}:</strong>
                          </label>
                          <select
                            value={plan.selectedChildren?.[roomIndex] || 0}
                            onChange={(e) =>
                              handleGuestInput(
                                plan.ratePlanId,
                                plan.roomId,
                                roomIndex,
                                "children",
                                Number(e.target.value)
                              )
                            }
                            className="form-select"
                            style={{
                              width: "60px",
                              fontSize: "10px",
                              padding: "2px",
                            }}
                          >
                            {(() => {
                              const room = rooms.find(
                                (r) => r._id === plan.roomId
                              );
                              return [
                                ...Array(
                                  (room?.maxchild || selectedChildren) + 1
                                ).keys(),
                              ].map((i) => (
                                <option key={i} value={i}>
                                  {i}
                                </option>
                              ));
                            })()}
                          </select>
                        </div>

                        {(() => {
                          const room = rooms.find((r) => r._id === plan.roomId);
                          return room?.extrabed ? (
                            <div className="d-flex align-items-center mt-2">
                              <label>
                                <strong>{t("homescreen.extra_bed")}:</strong>
                              </label>
                              <Button
                                type="primary"
                                onClick={() =>
                                  toggleExtraBed(
                                    plan.ratePlanId,
                                    plan.roomId,
                                    roomIndex
                                  )
                                }
                                style={{
                                  marginLeft: "1rem",
                                  fontSize: "10px",
                                  padding: "2px 4px",
                                  height: "24px",
                                }}
                              >
                                {plan.extraBed?.[roomIndex] ? "Remove" : "Add"}
                              </Button>
                            </div>
                          ) : null;
                        })()}

                        {plan.extraBed?.[roomIndex] && (
                          <p>
                            {t("homescreen.extra_bed_fee")}:
                            <Tag color="blue">
                              {formatCurrency(
                                extraBedPrice * totaldays,
                                currency,
                                convertAmount
                              )}
                              {currency}/{totaldays} night
                            </Tag>
                          </p>
                        )}
                      </div>
                    ))}
                    <div className="d-flex align-items-center mt-3">
                      <label>
                        <strong>{t("homescreen.no_of_room")}:</strong>
                      </label>
                      <select
                        value={plan.selectedRooms}
                        onChange={(e) =>
                          handleRoomChange(
                            plan.ratePlanId,
                            plan.roomId,
                            Number(e.target.value)
                          )
                        }
                        className="form-select"
                        style={{
                          marginLeft: "1rem",
                          width: "70px",
                          fontSize: "10px",
                          padding: "1px 2px",
                        }}
                      >
                        {(() => {
                          const room = rooms.find((r) => r._id === plan.roomId);
                          const maxSelectableRooms = getAvailableRooms({
                            room,
                            excludeRatePlanId: plan.ratePlanId,
                            fromdate,
                            todate,
                            bookingSidebar,
                          });
                          return [...Array(maxSelectableRooms + 1).keys()].map(
                            (i) => (
                              <option key={i} value={i} disabled={i === 0}>
                                {i}
                              </option>
                            )
                          );
                        })()}
                      </select>
                    </div>
                  </div>
                )}
              </div>
            )}
            {index < bookingSidebar.length - 0 && <Divider />}
          </div>
        ))}
      <p
        style={{
          fontSize: "20px",
          fontStyle: "bold",
          color: "#FFF",
          fontFamily: "Bebas Neue",
        }}
      >
        <strong>{t("homescreen.grand_total")}: </strong>
        <Tag
          color="blue"
          style={{
            fontSize: "20px",
            padding: "5px",
            fontFamily: "Bebas Neue",
          }}
        >
          <strong>
            {formatCurrency(
              calculateGrandTotal({
                bookingSidebar,
                extraBedPrice,
                totaldays,
              }),
              currency,
              convertAmount
            )}
          </strong>
        </Tag>
      </p>
      <div className="sticky-footer">
        <Button
          variant="primary"
          onClick={handleContinueToCheckout}
          style={{
            width: "100%",
            color: roomNameColor,
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          <strong>{t("homescreen.continue_checkout")}</strong>
        </Button>
      </div>
    </div>
  );
};
